import React, {useState} from 'react';
import {  Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//icons
import { AiOutlineHeart } from 'react-icons/ai';
//api
import { addItemCart } from 'api/ecommerce';
//redux
import { userSelector } from 'slices/user';
import { addItem } from 'slices/cart';
import { useDispatch, useSelector } from 'react-redux';
//preview books without covers
import preview from 'assets/img/preview.jpg';
import CoverImg from '../coverImage/CoverImage';
import Authors from '../authors';
//helpers
import { detailTypeProductRedirect } from '../../helpers';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import Button from 'components/userzone/buttons/ButtonCustom';

const ItemFavorite = (props) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(['home', 'backoffice']);
  const { data } = props;
  const dispatch = useDispatch();
  const { isLogged } = useSelector(userSelector);
  const { assignedLibrary} = useAssignedLibrary();

  const addProductToCart = async (data) => {
    if (isLogged) {
      setLoading(true);
      const payload = { item: data?.id, quantity: 1 };
      const { status } = await addItemCart(payload);
      if (status === 201) {
        dispatch(addItem(data));
      } else {
      }
    } else {
      dispatch(addItem(data));
    }
    setLoading(false);
  };

  const goUp = () => {
    window.scrollTo(0, 0);
  };

  const tooltip = (
    <Tooltip id="tooltip">
      <h5 className="m-0 text-tooltip">{t('seeProduct', { ns: 'home' })}</h5>
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="bottom" overlay={tooltip}>
      <div className="store-item container-favorites">
        <div className="store-cover">
          <div
            className={`img-container ${props.isReview ? 'img-review' : ''} ${props.isReview ? 'default-cursor' : 'pointer-cursor'
              }`}
          >
            <div className="overlay"></div>
            <Link to={detailTypeProductRedirect(data.product_detail, assignedLibrary)} onClick={goUp}>
              <CoverImg
                src={data?.product_detail.image || data?.image || data?.cover || preview}
                className="default-cursor"
              />
            </Link>
          </div>
          {!props.isAward && !props.isReview && (
            <div className="markers">
              {props.is_novelty && <p className="markers-novelty">{t('novelty')}</p>}
              {props.is_ebook && <p className="markers-ebook">EBOOK</p>}
            </div>
          )}
        </div>
        <Row className={`img-caption ${props.isAward ? '' : 'img-caption-no-margin'}`}>
          <Col xs={12}>
            {!props.isReview ? (
              <Link className="store-item__link" to={detailTypeProductRedirect(data.product_detail)}>
                <h5 className="title-favorites limit-long" title={data?.product_detail.title}>
                  {data?.product_detail.title.charAt(0).toUpperCase() + data?.product_detail.title.slice(1).toLowerCase()}
                </h5>
              </Link>
            ) : (
              <h5 className="title-favorites limit-long" title={data?.product_detail.title}>
                {data?.title.charAt(0).toUpperCase() + data?.product_detail.title.slice(1).toLowerCase()}
              </h5>
            )}
          </Col>
          <Col xs={12} className="d-flex justify-content-center">
            {data?.product_detail.authors && <Authors elements={data?.product_detail.authors} />}
          </Col>
        </Row>
        {props.isAward ? (
          <p className="mb-3 text-black-editorial">{data?.product_detail?.editorial?.nombre_fiscal}</p>
        ) : props.isReview ? (
          <Link
            className="blue text-center custom-link"
            to={`/pequenas-resenas/?small_reviews_id=${data?.product_detail?.editorial?.id}`}
          >
            {t('watchMore')}
          </Link>
        ) : (
          <p className="store-item-price mb-1">{props.data?.product_detail.price} €</p>
        )}

        {!props.isReview && (
          <div className="text-center">
            <Button
              variant="outline-dark"
              size="sm"

              className={`${props?.childList ? 'goldenBtn' : ''} btn-favorites`}
              onClick={() => addProductToCart(data.product_detail)}
              disabled={!data?.product_detail.has_stock}
            >
              {data?.product_detail.has_stock ? t('anadirCesta') : t('outOfStock')}
            </Button>
            <div className="center margin-top-xs">
              <Link to={`/${assignedLibrary}/favoritos`} className="link-favorite" onClick={() => props.removeProductFav(data)}>
                <AiOutlineHeart className="icon-md icon-secondary" />
                <span className="icon-secondary "> {t('backoffice:eliminar')}</span>
              </Link>
            </div>
          </div>
        )}
      </div>
    </OverlayTrigger>
  );
};

export default ItemFavorite;
